import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";import styled from '@emotion/styled'
import {Close} from '@mui/icons-material'
import * as Toast from '@radix-ui/react-toast'
import {snackbarShadow} from '../styles/elevation'
import {PALETTE} from '../styles/paletteV3'
import {Radius, ZIndex} from '../types/constEnums'

import SnackbarMessageAction from './SnackbarMessageAction'









const Text = styled('div')({
  color: '#FFFFFF',
  fontSize: 14,
  padding: '6px 8px'
})

const MessageStyles = styled('div')({
  alignItems: 'center',
  background: PALETTE.SLATE_700,
  borderRadius: Radius.SNACKBAR,
  boxShadow: snackbarShadow,
  display: 'flex',
  padding: 8,
  pointerEvents: 'auto',
  userSelect: 'none',
  zIndex: ZIndex.SNACKBAR
})

const DismissButton = styled('button')({
  border: 'none',
  backgroundColor: 'inherit',
  marginLeft: '8px',
  cursor: 'pointer',
  padding: 5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
})

const StyledIcon = styled(Close)({
  color: PALETTE.SLATE_500,
  height: 18,
  width: 18,
  '&:hover': {
    opacity: 0.5
  }
})

const SnackbarMessage = (props) => {
  const {action, secondaryAction, message, dismissSnack, showDismissButton} = props
  return (
    _jsx('div', { className: "pb-2 print:hidden" , children: 
      _jsxs(MessageStyles, { onClick: dismissSnack, children: [
        _jsx(Toast.Description, { asChild: true, children: 
          _jsx(Text, { children: message})
        })
        , _jsx(SnackbarMessageAction, { action: action,} )
        , _jsx(SnackbarMessageAction, { action: secondaryAction,} )
        , showDismissButton && (
          _jsx(DismissButton, {
            onClick: (e) => {
              e.stopPropagation()
              dismissSnack()
            },
 children: 
            _jsx(StyledIcon, {} )
          })
        )
      ]})
    })
  )
}

export default SnackbarMessage
